import React from "react";
import styles from "./SignInLeftSuperUser.module.css";
import qaLogo from "../../../assets/images/QA_logo.png";
import QuickAsystLogo from "../../../assets/images/QuickAsystFullLogoLeft.png";

const SignInLeftSuperUser: React.FC = () => {
  return (
    <div className={styles.hero}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        <div className={styles.logoBox}>
            <div className={styles.logo}>
                <img src={QuickAsystLogo} alt="QA Logo"/>
            </div>
        </div>
        <p className={styles.subtitle}>QuickAsyst Admin Dashboard</p>
        <h1 className={styles.title}>
          Easily manage the entire QuickAsyst operation from one central hub
        </h1>
        <p className={styles.tagline}>Sell Your Ticket. Everywhere.</p>
        <div className={styles.qaBadge}>
          <img src={qaLogo} alt="QA" />
        </div>
      </div>
    </div>
  );
};

export default SignInLeftSuperUser;
